import { get, writable } from "svelte/store";
import SatelliteViewType from "./Type";
import MapLayer from "../../Map/Enums/MapLayer";
import MapLayerGroup from "../../Map/Enums/MapLayerGroup";
import MapDataSource from "../../Map/Enums/MapDataSource";
import MapLayerManager from "../../Map/MapLayerManager";
import VisibilityState from "../../Map/Enums/VisibilityState";

const SatelliteViewStore = {
	meta: {
		type: writable(SatelliteViewType.OFF),
		opacity: writable(1.0),
		initted: writable(false),
		visible: writable(false)
	},
	actions: {
		init: (map) => {
			const initted = get(SatelliteViewStore.meta.initted);
			if (!initted) {
				map.addSource(MapDataSource.SATELLITE_TILES, {
					tileSize: 256,
					type: "raster",
					url: "mapbox://mapbox.satellite"
				});
				map.addLayer({
					id: MapLayer.SATELLITE_TILES,
					layout: {},
					metadata: {
						"mapbox:featureComponent": "satellite",
						"mapbox:group": "Satellite imagery, land"
					},
					paint: {},
					source: MapDataSource.SATELLITE_TILES,
					type: "raster"
				}, "hillshade"); // map.getStyle().layers[0].id);

				MapLayerManager.addLayerGroup(MapLayerGroup.SATELLITE_TILES, [MapLayer.SATELLITE_TILES], [MapDataSource.SATELLITE_TILES]);

				SatelliteViewStore.actions.update(map);
				SatelliteViewStore.meta.initted.set(true);

				/*
				map.addSource("10m-bathymetry-81bsvj", {
					type: "vector",
					url: "mapbox://mapbox.9tm8dx88"
				});

				map.addLayer(
					{
						id: "10m-bathymetry-81bsvj",
						type: "fill",
						source: "10m-bathymetry-81bsvj",
						"source-layer": "10m-bathymetry-81bsvj",
						layout: {},
						paint: {
							"fill-outline-color": "hsla(337, 82%, 62%, 0)",
							// cubic bezier is a four point curve for smooth and precise styling
							// adjust the points to change the rate and intensity of interpolation
							"fill-color": [
								"interpolate", ["cubic-bezier", 0, 0.5, 1, 0.5],
								["get", "DEPTH"],
								200,
								"#78bced",
								9000,
								"#15659f"
							]
						}
					},
					"hillshade" // land-structure-polygon"
				);
				*/
			}
		},
		update: (map) => {
			const type = get(SatelliteViewStore.meta.type);
			const visible = (type !== SatelliteViewType.OFF);

			if (!map.getLayer(MapLayer.SATELLITE_TILES)) {
				return;
			}

			map.setLayoutProperty(MapLayer.SATELLITE_TILES, "visibility", (visible ? VisibilityState.VISIBLE : VisibilityState.NONE));

			const opacity = get(SatelliteViewStore.meta.opacity);
			if (type === SatelliteViewType.REGULAR) {
				map.setPaintProperty(MapLayer.SATELLITE_TILES, "raster-saturation", 0.0);
				map.setPaintProperty(MapLayer.SATELLITE_TILES, "raster-contrast", 0.0);
				map.setPaintProperty(MapLayer.SATELLITE_TILES, "raster-opacity", opacity);
			}
			else if (type === SatelliteViewType.SATURATED) {
				map.setPaintProperty(MapLayer.SATELLITE_TILES, "raster-saturation", 0.5);
				map.setPaintProperty(MapLayer.SATELLITE_TILES, "raster-contrast", 0.0);
				map.setPaintProperty(MapLayer.SATELLITE_TILES, "raster-opacity", opacity);
			}
			else if (type === SatelliteViewType.GREYSCALE) {
				map.setPaintProperty(MapLayer.SATELLITE_TILES, "raster-saturation", -1.0);
				map.setPaintProperty(MapLayer.SATELLITE_TILES, "raster-contrast", 0.1);
				map.setPaintProperty(MapLayer.SATELLITE_TILES, "raster-opacity", opacity);
			}
			else if (type === SatelliteViewType.SEPIA) {
				map.setPaintProperty(MapLayer.SATELLITE_TILES, "raster-saturation", -1.0);
				map.setPaintProperty(MapLayer.SATELLITE_TILES, "raster-contrast", 0.0);
				map.setPaintProperty(MapLayer.SATELLITE_TILES, "raster-opacity", 0.75 * opacity);
				map.setPaintProperty(MapLayer.SATELLITE_TILES, "raster-fade-duration", 50);
			}
		}
	}
};
export default SatelliteViewStore;
